import type { ReactNode } from "react";

type SubtleAccordionGroupProps = {
  children: ReactNode;
};

export default function SubtleAccordionGroup({
  children,
}: SubtleAccordionGroupProps) {
  return <div className="divide-y divide-slate-200">{children}</div>;
}
